import React, { type FC } from "react";

import { pluralize } from "~/tools/pluralize";

export const DataCountInformation: FC<{ total: number }> = ({ total }) => {
	const prefix = total === 0 ? "There are" : "Showing";

	const pluralizeLogs = pluralize({
		0: "no log entries",
		1: "1 log entry",
		more: (count) => `${count} log entries`,
	});

	return (
		<div className="flex shrink-0 font-normal text-grey-800 leading-8">
			{prefix} <span className="mx-1 font-medium">{pluralizeLogs(total)}</span> matching your criteria
		</div>
	);
};
